/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import configData from "./../../config.json";
import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import Icon from "./../Varios/Icons.js";
import CardPersonal from "./../Varios/CardPersonal.js";
import DemoNavbar from "components/Navbars/Navbar.js";
import { authenticationService } from '../../services/authentication.service';

var ps;
const API_URL = configData.SERVER_URL
const id = 1043;

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.activeRoute.bind(this);
        this.state = {
            currentUser: null,
            identificacion: "",
            nombres: "",
            apellidos: ""
        };
        /*
        if (this.state.usuario !== null) {

            //API PARA OBTENER PERSONA
            fetch(API_URL + "DatosGenerales/PersonaPorUsuario/" + this.state.usuario)
                .then(res => res.json())
                .then(
                    (result) => {

                        if (result.strEstado === "S") {
                            this.setState({
                                identificacion: result.entTabla[0]['numeroidentificacion'],
                                nombres: result.entTabla[0]['nombres'],
                                apellidos: result.entTabla[0]['apellidos'],
                            });
                        } else {
                            throw new Error(result.strMensaje);
                        }
                    },
                    (error) => {
                        alert(error);
                        this.setState({
                            loading: false,
                            error,
                        });
                        throw new Error("Ocurrió un error");
                    }
                )
        }
        */
    }


    // verifies if routeName is the one active (in browser input)
    activeRoute(routeName) {
        //return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
        return this.props.location.pathname === routeName ? "active" : "";
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(x => this.setState({
            currentUser: x,
        }));

        if (navigator.platform.indexOf("Win") > -1) {
            ps = new PerfectScrollbar(this.refs.sidebar, {
                suppressScrollX: true,
                suppressScrollY: false,
            });
        }
    }

    componentWillUnmount() {
        if (navigator.platform.indexOf("Win") > -1) {
            ps.destroy();
        }
    }

    render() {
        return (
            <div className="sidebar">
                <div className="sidebar-wrapper ps ps--active-y" ref="sidebar">
                    {this.state.currentUser ?
                        <CardPersonal identificacion={this.state.currentUser.identificacion} apellidos={this.state.currentUser.apellidos} nombres={this.state.currentUser.nombres} />
                        : ''}

                    <Nav>
                        {this.props.routes.map((prop, key) => {
                            let color = this.activeRoute(prop.layout + prop.path) ? "#FFF" : "#243165";
                            if (prop.redirect) return null;
                            if (!this.state.currentUser) return null;
                            if (!prop.rol || prop.rol.includes(this.state.currentUser.roles[0])) {
                                return (
                                    <li
                                        style={{ backgroundColor: prop.color, marginBottom: "-5px" }}
                                        className={"menuButton " +
                                            this.activeRoute(prop.layout + prop.path) +
                                            (prop.pro ? " active active-pro" : "")
                                        }
                                        key={key}
                                    >
                                        <NavLink
                                            to={prop.layout + prop.path}
                                            className="nav-link"
                                            activeClassName="active"
                                        >
                                            <div className="container_opciones">
                                            {(<Icon className="item-left" kind={prop.icon} fill={color} width={32} height={32} style={{ marginRight: 12 }} />)}
                                            <div className="item-right">{prop.name}</div>

                                            </div>
                                            {/* {prop.icon.startsWith("fa-") ? (<i className={"fas " + prop.icon} style={{ color: prop.color }} aria-hidden="true"></i>) : (<Icon kind={prop.icon} fill={color} width={32} height={32} style={{ marginRight: 12 }} />)} */}

                                                {/* <div className="col-2">
                                                    {(<Icon kind={prop.icon} fill={color} width={32} height={32} style={{ marginRight: 12 }} />)}

                                                </div>
                                                <div className="col">
                                                    <span className="">{prop.name}</span>

                                                </div> */}
                                        </NavLink>
                                    </li>
                                );
                            }
                            else {
                                return null;
                            }

                        })}
                    </Nav>
                </div>
            </div>
        );
    }
}

export default Sidebar;